<template>
  <div class="expertThinkTank">
    <comHead :tabIndexI="6" :imgSrc="imgSrc" />

    <div class="content-bg">
      <div class="content">
        <!-- <button class="anniu" @click="number = 0" :class="{ newAnniu: 0 === number }">鼎宏人才观</button>
        <button class="anniu" @click="number = 1" :class="{ newAnniu: 1 === number }">社会招聘</button> -->
        <el-tabs v-model="selectedTab">
          <el-tab-pane label="鼎宏人才观" name="a" @click="selectedTab = 'a'" :class="{ newAnniu: selectedTab == 'a' }">
          </el-tab-pane>
          <el-tab-pane label="社会招聘" name="b" @click="selectedTab = 'b'" :class="{ newAnniu: selectedTab == 'b' }">
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="bgImage" v-if="'a' == selectedTab">
      <div class="talent">
        <h1>期待你的加入</h1>
        <div class="talentParagraph">
          <p>
            鼎宏集团于2009年成立，是国内知名的知识产权全产业链品牌服务机构。秉承“
            鼎兴中国知识产权，宏扬中华民族品牌”的伟大使命，紧跟国家战略部署，围绕知识产权
            创造、运用、保护、管理和服务，积极投身于知识产权事业建设。
          </p>
          <p>
            未来，期待有激情、有梦想，敢创新、敢挑战的你，加入我们，一起探讨、学习、共享知识，携手共进，共谋发展！
          </p>
        </div>
      </div>

      <div class="companyCenter">
        <h1>公司形象照片</h1>
        <ul class="companyPhoto">
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo1.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo2.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo3.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo4.jpg" alt="" />
          </li>
        </ul>
        <ul class="companyPhoto">
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo5.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo6.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo7.jpg" alt="" />
          </li>
        </ul>
        <ul class="companyPhoto">
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo8.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo9.jpg" alt="" />
          </li>
          <li class="photo">
            <img src="../../static/imgs/joinDH/photo10.jpg" alt="" />
          </li>
        </ul>
      </div>
    </div>

    <div class="recruitment" v-if="'b' == selectedTab">
      <div class="recruitmentCenter">
        <ul class="recruitmentLeft">
          <li v-for="(item, index) in types" :key="index" @click="selectType(item.Value)"
            :class="selectedType == item.Value ? 'checked' : ''">
            {{ item.FullName }}
          </li>
        </ul>
        <div class="recruitmentRight">
          <div class="recruitmentTitle">
            <h1>职位</h1>
            <div>{{ this.totalCount }}</div>
          </div>
          <div v-if="list.length < 1" style="height: 136px"></div>
          <div class="positionCenter" v-for="(item, index) in list" :key="index">
            <div class="positionAll">
              <div class="position">
                {{ item.JobTitle }}
                <span>new</span>
              </div>
              <div class="time">{{ item.ReleaseDate.split("T")[0] }} 发布</div>
            </div>
            <div class="Small">
              <div class="buju">
                <div class="SmallZi">
                  <div class="place">
                    <div class="placePhoto">
                      <img src="../../static/imgs/joinDH/dignwei.png" alt="" />
                    </div>
                    <div class="tect">工作地点：{{ item.WorkPlace }}</div>
                  </div>
                  <div class="xiantiao"></div>
                  <div class="place">
                    <div class="placePhoto">
                      <img src="../../static/imgs/joinDH/zhuanye.png" alt="" />
                    </div>
                    <div>专业技能类：{{ item.Specialty }}</div>
                  </div>
                </div>
                <div class="show" @click="toggle(item.JobId)">
                  {{ showId == item.JobId ? "收起" : "展开" }}
                </div>
              </div>
              <div class="detailed" v-if="showId == item.JobId">
                <h1>岗位职责：</h1>
                <p v-html="item.Responsibilities"></p>
                <h1>任职条件：</h1>
                <p v-html="item.Requirements"></p>
                <div class="email">
                  简历投递邮箱：<span>{{ item.Mailbox }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="pagination">
            <el-pagination layout="prev, pager, next" @current-change="pageIndexChange" :page-size.sync="pageSize" :current-page.sync="pageIndex"
              :page-size="pageSize" :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <comFooter />
  </div>
</template>

<script>
import { getCodeLsit, getJobOffersList } from "../request/api.js";
export default {
  data() {
    return {
      imgSrc: require("../../static/imgs/joinDH/joinDH.jpg"),
      positionID: this.$route.query.positionID,
      selectedTab: "a",
      sss: false,
      types: [],
      list: [],
      pageIndex: 1,
      pageSize: 5,
      totalCount: 0,
      selectedType: 0,
      showId: 0,
    };
  },
  created() {
    getCodeLsit({ code: "JobType" }).then((data) => {
      if (data.StatusCode == 200) {
        this.types = data.Result || [];
        this.selectedType = this.types[0].Value;
        this.loadList();
      } else console.log(data.Msg);
    });
  },
  mounted() {

  },
  methods: {
    toggle(id) {
      if (this.showId == id) {
        this.showId = 0;
      } else {
        this.showId = id;
      }
    },
    selectType(typeid) {
      this.selectedType = typeid;
      this.pageIndex = 1;
      this.loadList();
    },
    pageIndexChange(val) {
      this.pageIndex = val;
      this.loadList();
      this.toTop();
    },
    loadList() {
      getJobOffersList({
        PageInfo: {
          PageIndex: this.pageIndex - 1,
          PageSize: this.pageSize,
        },
        JobType: this.selectedType,
      }).then((data) => {
        console.log(data.Result);
        console.log(data.TotalCount);
        this.list = data.Result;
        this.totalCount = data.TotalCount;
      });
    },
    toTop() {
      const that = this;
      let timer = setTimeout(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearTimeout(timer);
        }
      }, 30);
    },
  },
  props: {
    tabIndexI: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

/deep/ .el-tabs__item.is-active {
  font-size: 1.25rem !important;
  line-height: 1rem !important;
  color: #0055a2 !important;
}

/deep/ .el-tabs__item {
  color: #333 !important;
  font-size: 1rem;
  height: auto;
}

/deep/ .el-tabs__active-bar {
  background: #0c56b0 !important;
}

/deep/ .el-tabs__nav-wrap::after {
  background: none !important;
}

.expertThinkTank {
  background: #fff !important;

  .content-bg {
    background: #f7f7f7 !important;
    padding: 2rem;
    margin-bottom: 3.75rem;

    .content {
      width: 62.5vw;
      min-width: 1200px;
      height: auto;
      margin: 0 auto;
      display: flex;
      align-items: center;

      .anniu {
        font-size: 1rem;
        color: #333;
        margin-right: 3.75rem;
        background: none;

        padding-bottom: 0.625rem;
      }

      .newAnniu {
        font-size: 1.25rem;
        color: #0055a2;
        border-bottom: #0055a2 solid 0.125rem;
        padding-bottom: 0.625rem;
        background: none;
      }
    }
  }

  .bgImage {
    background: url(../../static/imgs/joinDH/bg.png) no-repeat bottom;
  }

  .talent {
    background: url(../../static/imgs/joinDH/rencaiguan.jpg) no-repeat top;
    max-width: 1200px;
    margin: 0 auto;

    h1 {
      font-size: 1.25rem;
      color: #fff;
      padding: 3.125rem 0 1.875rem 2.5rem;
      font-weight: bold;
    }

    .talentParagraph {
      font-size: 1rem;
      color: #fff;
      padding-left: 2.5rem;
      width: 34%;
      padding-bottom: 15.25rem;
    }

    p {
      width: 100%;
      line-height: 1.6rem;
      text-indent: 1.8rem;
      margin-bottom: 1.25rem;
    }
  }

  .companyCenter {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 3rem;

    h1 {
      font-size: 2.25rem;
      color: #333;
      padding: 2rem 0 3rem;
    }

    .companyPhoto {
      display: flex;
      margin-bottom: 10px;
      max-width: 1200px;

      .photo {
        margin-right: 10px;
      }

      .companyPhoto :last-child {
        margin-right: 0 !important;
      }
    }
  }

  .recruitment {
    .recruitmentCenter {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;

      .recruitmentLeft {
        width: 30%;
        margin-right: 1.875rem;

        li {
          padding: 1.75rem 6.875rem;
          border: 0.0625px solid #f0f0f0;
          margin-bottom: 1.25rem;
          color: #333;
          cursor: pointer;
        }
      }

      .recruitmentRight {
        width: 70%;
        border: 0.0625px solid #f0f0f0;
        padding: 2rem 0 0;
        margin-bottom: 3.2rem;

        .recruitmentTitle {
          padding: 0 1.875rem;
          display: flex;
          align-items: center;
          margin-bottom: 1rem;

          h1 {
            font-size: 1.5rem;
            color: #333;
            margin-right: 0.5rem;
          }

          div {
            font-size: 1rem;
            border-radius: 40rem;
            width: 3rem;
            height: 1.5rem;
            background: #0055a2;
            line-height: 1.5rem;
            text-align: center;
            color: #fff;
          }
        }

        .positionCenter {
          padding: 2rem 1.875rem 0 1.875rem;

          .positionAll {
            display: flex;
            justify-content: space-between;

            .position {
              font-size: 1.25rem;
              color: #333;

              span {
                font-size: 0.875rem;
                border-radius: 40rem;
                padding: 0 0.5rem;
                height: 1.5rem;
                background: #e5eef6;
                width: 3rem;
                height: 1.5rem;
                line-height: 1.5rem;
                color: #0055a2;
              }
            }

            .time {
              color: #666;
              font-size: 0.875rem;
            }
          }

          .Small {
            border-bottom: 0.0625px solid #f0f0f0;

            margin-top: 1.2rem;
            padding: 0 0 2rem;

            .buju {
              display: flex;
              justify-content: space-between;
            }

            .SmallZi {
              display: flex;
              align-items: center;

              .place {
                display: flex;
                font-size: 0.875rem;
                color: #666;

                .placePhoto {
                  margin-right: 0.5rem;
                }
              }

              .xiantiao {
                width: 0.1rem;
                height: 1rem;
                background: #ccc;
                margin: 0 1.5rem;
              }
            }

            .show {
              font-size: 0.875rem;
              color: #666;
              width: 3rem;
              height: 1.5rem;
              border-radius: 0.2rem;
              background: #e5e5e5;
              text-align: center;
              line-height: 1.5rem;
              cursor: pointer;
            }

            .show:hover {
              color: #0055a2;
              background: #e5eef6;
            }

            .detailed {
              h1 {
                margin-bottom: 1.2rem;
                font-size: 0.875rem;
                color: #333;
                margin-top: 1.6rem;
              }

              p {
                font-size: 0.875rem;
                color: #666;
                line-height: 1.5rem;
              }

              .email {
                font-size: 0.875rem;
                color: #333;
                margin-top: 1.6rem;

                span {
                  color: #0055a2;
                }
              }
            }
          }
        }

        .positionCenter:hover {
          background: #f7f7f7;
        }
      }
    }

    .pagination {
      margin: 3rem 0;
      text-align: center;
    }
  }

  .checked {
    background: #f7f7f7 !important;
    color: #0055a2 !important;
  }
}
@media screen and(max-width: 500px) {
	.expertThinkTank{
		width: 100vw;
		.content-bg{
			padding: 5px;
			margin-bottom: auto;
			.content{
				width: 100%;
				min-width: auto;
			}
		}
		.talent{
			max-width: 100vw;
			background-size: 100%;
			background-color: #0055a2;
			h1{
				padding: 80px 5px 0px 5px;
			}
			.talentParagraph{
				width: 100vw;
				padding: 110px 5px 5px 5px;
			}
		}
		.companyCenter{
			max-width: 100vw;
			.companyPhoto{
				max-width: 100vw;
				display: initial;
				.photo{
					img{
						width: 98vw;
						margin: 5px;
					}
				}
			}
		}
		.recruitment{
			.recruitmentCenter{
				max-width: 100vw;
				display: initial;
				.recruitmentLeft{
					width: 90vw;
					margin: 0 auto;
					li{
						margin: 10px auto;
						text-align: center;
					}
				}
				.recruitmentRight{
					width: 100vw;
					padding: 5px;
				}
			}
		}
	}
	}
</style>
